import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { initKeycloak } from "./auth/keycloakService";
import { initPermissionClient } from "@merncloud/permission-resolver/frontend";
import { apiClient } from "./services/apiService";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const startApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

initKeycloak()
  .then(async () => {
    console.log("Keycloak initialized successfully.");
    await initPermissionClient({
      fetchRules: () => apiClient.get("/permissions"),
    });
  })
  .then(() => {
    console.log("Permission client initialized successfully.");
    startApp();
  })
  .catch((err) => {
    console.error("Keycloak init failed", err);
    root.render(
      <React.StrictMode>
        <div>
          <h1>Keycloak Initialization Failed</h1>
          <p>Please check your network connection or contact support.</p>
        </div>
      </React.StrictMode>
    );
  });

// const renderComponent = () => {
//   root.render(
//     <React.StrictMode>
//       <>Your component to test</>
//     </React.StrictMode>
//   );
// };

// renderComponent();

reportWebVitals();
